var exports = {
  "kL": "xcc377c0b--acbbd7--container",
  "Dy": "xcc377c0b--acbbd7--names",
  "x8": "xcc377c0b--acbbd7--names-text",
  "x6": "xcc377c0b--acbbd7--button",
};

module.exports = exports;
